import type { ReactNode } from 'react';

/**
 * Pinned action bar under a scrolling panel (e.g. the compose column):
 * top border, padding, and a one-row layout where every action gets an
 * equal share. Hosts pass the buttons; the flex/gap live here so DMC and
 * TO footers stay identical.
 */
export default function KoobActionsFooter({
  children,
}: {
  children: ReactNode;
}) {
  return (
    <div className="shrink-0 border-t border-solid border-gray-200 bg-white p-4">
      {/* grow, not flex-1: equal halves squeezed a wide split button under
          its neighbour. A max-content basis keeps every action at least
          content-wide (block buttons would otherwise start at 100%), and
          wrapping stacks them when the column is too narrow for one row. */}
      <div className="flex flex-wrap items-center gap-3 [&>*]:grow [&>*]:basis-[max-content]">
        {children}
      </div>
    </div>
  );
}
